/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Field_DistrictInputs */

const cs_addr_field_district = /** @type {(inputs: Addr_Field_DistrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Část obce`)
};

const en_addr_field_district = /** @type {(inputs: Addr_Field_DistrictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City part`)
};

/**
* | output |
* | --- |
* | "City part" |
*
* @param {Addr_Field_DistrictInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_field_district = /** @type {((inputs?: Addr_Field_DistrictInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Field_DistrictInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_field_district(inputs)
	return cs_addr_field_district(inputs)
});